import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
function Header() {
  const navigate = useNavigate();
  const location = useLocation(); // Get the current route path
  const headers = {
    "/MyOrderds": { title: "Ordered List" },
    "/Productlist": { title: "My Products" },
    "/Profile": { title: "More Setting" },
    "/ProductDetails": { title: "Product Detail", backLink: true },
    "/AllProducts": { title: "All Product List" },
    "/Size": { title: "Size List", backLink: "/skip" },
    "/Products": { title: "Product List", backLink: "/skip" },
    "/terms": { title: "Terms And Conditions", backLink: "/skip" },
    "/privacy": { title: "Privacy Policy", backLink: "/skip" },
    "/HelpAndSupport": { title: "Help & Support", backLink: "/skip" },
    "/Inquiry": { title: "Inquiry", backLink: true },
    "/registration": { title: "Registration", backLink: "/Logout" },
  };

  const currentHeader = Object.entries(headers).find(([path]) =>
    location.pathname.startsWith(path)
  );

  return (
    <div className="header fixed top-0 left-0 w-full bg-white z-50">
      {/* Home Header */}
      {location.pathname === "/skip" && (
        <div
          className="content notch-clear bg-white"
          style={{ margin: "0px 10px 10px 10px",boxShadow:"unset" }}
        >
          <div className="d-flex py-2">
            <div className="align-self-center me-auto">
              <h1 className="font-27" style={{marginTop: '0.5rem'}}> Welcome Back</h1>
            </div>
            <div className="align-self-center ms-auto">
              <Link className="d-block" data-menu="menu-events">
                <img
                  src="https://aghomedecor.in/fmcg_upload/logo/060325021608logo1.jpg"
                  className="img-fluid shadow-xl rounded-circle"
                  width="52"
                  alt="Profile"
                />
              </Link>
            </div>
          </div>
        </div>
      )}

      {/* Dynamic Headers */}
      {currentHeader && (
        <div
          style={{ width: "100%", display: "flex", margin: "5%" }}
          className="col-sm-4"
        >
          {currentHeader[1].backLink && (
            <Link
              style={{ height: "38px" }}
              to={currentHeader[1].backLink}
              onClick={() => navigate(-1)}
              className="icon icon-xs gradient-red rounded-xl"
            >
              <i className="fa fa-angle-left color-white"></i>
            </Link>
          )}
          <h1 style={{ marginLeft: "15px", width: "100%", marginTop: "3px" }}>
            {currentHeader[1].title}
          </h1>
        </div>
      )}
    </div>
  );
}

export default Header;
